const sessionStorageTokenName = "accessToken"
const redirectUri = process.env.VUE_APP_redirectUri
// const redirectUri = 'https://0cb9904e1b25.ap.ngrok.io'
const client_id = '1653926350'
const client_secret = 'f393e5e79c724ad7956c90d33e647ee2'

function redirect(){
    var URL = 'https://access.line.me/oauth2/v2.1/authorize?';
    URL += 'response_type=code';
    URL += `&client_id=${client_id}`;
    URL += `&redirect_uri=${redirectUri}`;
    URL += '&state=abcd';
    URL += '&scope=openid%20profile';
    window.location.href = URL;
}
function getAccessTokenRequest(code){
    return fetch("https://api.line.me/oauth2/v2.1/token",{
        method:"POST",
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:new URLSearchParams({
            grant_type:"authorization_code",
            client_id:`${client_id}`,
            client_secret:`${client_secret}`,
            code,
            redirect_uri:redirectUri,
        })
    }).then( res => res.json()).catch(()=>{
        redirect()
    })
}
function getProfile(accessToken){
    return fetch("https://api.line.me/v2/profile",{
        headers: { 'Authorization': `Bearer ${accessToken}` }
    }).then( res => res.json()).catch(()=>{
        redirect()
    })
}

function getUserToken(code){
    return new Promise((resolve)=>{
      if(!window.sessionStorage.getItem(sessionStorageTokenName)){
        getAccessTokenRequest(code).then( resJson => {
        //   console.log(resJson)

          if(resJson.error)redirect()
          
          else{window.sessionStorage.setItem(sessionStorageTokenName,resJson.access_token)}
          resolve(resJson.access_token)
        })
      }
      else{
        const accessToken = (window.sessionStorage.getItem(sessionStorageTokenName))
        resolve(accessToken)
      }
    })
}
function getUserData(){
    const url = window.location.search;
    if(!url && !window.sessionStorage.getItem(sessionStorageTokenName)){
      redirect()
    }
    const urlParams = url.replace('?', '')
    .split('&')
    .map(param => param.split('='))
    .reduce((values, [ key, value ]) => {
      values[ key ] = value
      return values
    }, {})
    return getUserToken(urlParams.code).then((token)=>{
      return getProfile(token)
    })
  }
module.exports = {
    redirect,getUserData
}